import React from 'react';

const PaymentCallback: React.FC = () => {
  return (
    <div>
      <h1>Payment Callback</h1>
      <p>Handle payment callback logic here.</p>
    </div>
  );
};

export default PaymentCallback; 